import Accordion from "../components/Accordion";
import BgCta from "../components/BgCta";
import CardsText from "../components/CardsText";
import ContactForm from "../components/ContactForm";
import Marquee from "../components/Marquee";
import PostLoader from "../components/PostLoader";
import Swipers from "../components/Swipers";
import { pxToRem } from "../inc/helpers";

export default class PageDefault {
    constructor(data) {
        this.data = data;
        // console.log(this.data);
    }

    init() {
        // console.log("Page Default");
        this.initSwipers();
        this.initPQueries();
        this.initCMarquees();
        this.initContactForms();
        this.initCardsText();
        this.initAccordions();
        this.initBgCtas();
    }

    initBgCtas() {
        const ctas = document.querySelectorAll(".js-bg-cta-card");
        ctas?.forEach((cta) => {
            const sectionPrevEls = cta
                ?.closest(".content-row")
                ?.previousElementSibling?.querySelectorAll(".content-col");
            const bgCta = new BgCta({ el: cta, sectionPrevEls });
        });
    }

    initAccordions() {
        const accs = document.querySelectorAll(".js-accordion");
        accs?.forEach((acc) => {
            const btnAnchor = document.querySelector(`a[href='#${acc.id}']`);
            const accordion = new Accordion({
                container: acc,
                btn: acc.querySelector(".js-btn-accordion"),
            });

            btnAnchor?.addEventListener("click", (e) => accordion.open(true));
        });
    }

    initCardsText() {
        const cardsTexts = document.querySelectorAll(".js-cards-text");
        cardsTexts?.forEach((container) => {
            const contParent = container.parentNode;
            const breakpoint = pxToRem(767);
            const slides = container.querySelectorAll(".card-text");
            const pagination = contParent.querySelector(
                ".js-cards-text-pagination",
            );
            const cardsText = new CardsText({
                contParent,
                container,
                breakpoint,
                slides,
                pagination,
            });
        });
    }

    initSwipers() {
        const swipers = new Swipers();
        swipers.init();
    }

    initPQueries() {
        const postsQueries = this.data?.posts ?? [];
        postsQueries.forEach((p) => {
            const { id, template, posts } = p;
            const container = document.querySelector(
                `.js-posts-query[data-loader-id="${p.id}"]`,
            );
            const btn =
                container?.parentNode.querySelector(".js-btn-load-more");
            const postLoader = new PostLoader({
                id,
                template,
                posts,
                container,
                btn,
            });
        });
    }

    initCMarquees() {
        const clientsMarquees = document.querySelectorAll(".js-clients");
        clientsMarquees.forEach((c) => {
            const entries = c.querySelectorAll(".client");
            const btn = c.parentNode.querySelector(".js-btn-play-pause");
            const marquee = new Marquee({ container: c, entries, btn });
            marquee.init();
        });
    }

    initContactForms() {
        const forms = document.querySelectorAll(".wpcf7-form");
        forms.forEach((f) => {
            const form = new ContactForm({ form: f });
        });
    }
}
